import Vue from 'vue';
import MenuTreeItem from './menu-tree-item/MenuTreeItem.vue';

export default Vue.extend({
  name       : 'SidebarV3',
  components : { MenuTreeItem },
  props      : {
    legacyLayout: {
      type    : Boolean,
      default : true
    },
    items: {
      type     : Array,
      required : true
    },
    allowSearch: {
      type    : Boolean,
      default : true
    }
  },
  data() {
    return {
      search: ''
    };
  },
  computed: {
    statusMini: {
      get() {
        return this.$store.state._core.application.statusMini;
      },
      set(val) {
        this.$store.commit('_core/application/SET_STATUS_MINI', val);
      }
    },
    isOpen: {
      get() {
        return this.$store.state._core.application.sidebarDrawer;
      },
      set(val) {
        this.$store.commit('_core/application/SET_SIDEBAR_DRAWER', val);
      }
    },
    filteredTreeItems() {
      /** @returns {any[]} */
      const filterInTree = (items = []) => {
        return items.reduce((previous, current) => {
          if (current.children) {
            const children = filterInTree(current.children);

            if (children.length > 0) {
              return [...previous, { ...current, children }];
            }

            return previous;
          }

          const matchSearch = current.title
            .toString()
            .toLowerCase()
            .includes(this.search.toLowerCase());
          if (!matchSearch) {
            return previous;
          }

          if (!current.grant) {
            return [...previous, current];
          }

          const matchPermissions = this.$safea.hasPermissions(current.grant);
          if (matchPermissions) {
            return [...previous, current];
          } else {
            return previous;
          }
        }, []);
      };

      return filterInTree(this.items);
    }
  },
  methods: {
    updateStatusMini(value) {
      this.$store.commit('_core/application/SET_STATUS_MINI', value);
    }
  }
});
